import Validation from "@/classes/global/Validation";

export default class ValidationBase {
    constructor() {
        this.validationMessages = ['Required', 'Max Number 20', 'Incorrect Format', 'Enter Search Text'];
        this.shipperName = new Validation();
        this.shipperRef =  new Validation();
        this.shipperAddressLine1 = new Validation();
        this.shipperAddressLine2 = new Validation();
        this.shipperCity = new Validation();
        this.shipperCounty = new Validation();
        this.shipperPostcode = new Validation();
        this.shipperCountry = new Validation();
        this.shipperVatNumber = new Validation();
        this.shipperContactFullName = new Validation();
        this.shipperContactTitle = new Validation();
        this.shipperContactFirstName = new Validation();
        this.shipperContactLastName = new Validation();
        this.shipperContactPhone = new Validation();
        this.shipperContactEmail = new Validation();
        this.shipperContactDepartment = new Validation();
        this.consigneeName = new Validation();
        this.consigneeRef = new Validation();
        this.additionalRef = new Validation();
        this.consigneeAddressLine1 = new Validation();
        this.consigneeAddressLine2 = new Validation();
        this.consigneeCity = new Validation();
        this.consigneeCounty = new Validation();
        this.consigneePostcode = new Validation();
        this.consigneeCountry = new Validation();
        this.consigneeVatNumber = new Validation();
        this.consigneeContactFullName = new Validation();
        this.consigneeContactTitle = new Validation();
        this.consigneeContactFirstName = new Validation();
        this.consigneeContactLastName = new Validation();
        this.consigneeContactPhone = new Validation();
        this.consigneeContactEmail = new Validation();
    }
}
